import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { DiscordIcon } from './icons/SvgIcons';
import { EXTERNAL_LINKS, CONTACT_INFO } from '@/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-background border-t border-border/40">
      <div className="container mx-auto px-4 py-8 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {/* Section Logo et À propos */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Mon Premier Jeu</h3>
            <p className="text-muted-foreground text-xs sm:text-sm">
            Apprends à coder tes jeux vidéo en PUR CODE sans moteur, sans installation, sans compilation, directement depuis ce site.
             Aucun prérequis nécessaire !
              </p>
             <p className="text-xs sm:text-sm text-muted-foreground pt-6 sm:pt-9">&copy; {currentYear} Mon Premier Jeu par MH Production. Tous droits réservés.</p>
          </div>
          
          {/* Section Liens rapides */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base mb-2 sm:mb-3">Liens rapides</h3>
            <ul className="space-y-0.5">
              <li><Link to="/courses" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors">Les cours</Link></li>
              <li><Link to="/projects" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors">Mes projets</Link></li>
              <li><Link to="/play" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors">Mes jeux</Link></li>
              <li><Link to="/pass-codeur" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors">Le Pass Codeur</Link></li>
              <li><Link to="/cgv" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors">CGV</Link></li>
            </ul>
          </div>
          

          {/* Section Contact et Réseaux */}
          <div className="sm:col-span-2 md:col-span-1">
            <h3 className="font-semibold text-sm sm:text-base mb-4 sm:mb-6">Rejoins la communauté</h3>
            <div className="mb-4 sm:mb-6">
              <a 
                href={EXTERNAL_LINKS.DISCORD} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center bg-[#5865F2] text-white hover:bg-[#4752C4] px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold text-sm sm:text-lg transition-colors"
              >
                <DiscordIcon className="mr-2 sm:mr-3 w-4 sm:w-6 h-4 sm:h-6" />
                Rejoindre Discord
              </a>
            </div>
            <div className="flex items-center text-xs sm:text-sm text-muted-foreground pt-4 sm:pt-7">
              <Mail size={14} className="mr-2 sm:hidden" />
              <Mail size={16} className="mr-2 hidden sm:block" />
              <a href={`mailto:${CONTACT_INFO.EMAIL}`} className="hover:text-primary transition-colors">
                {CONTACT_INFO.EMAIL}
              </a>
            </div>
          </div>
        </div>
        
       
      </div>
    </footer>
  );
};

export default Footer; 